'use client'
import { cva } from 'class-variance-authority'
import { cn } from '~/app/utils/utils'
import React from 'react'
import { motion } from "motion/react"

const CircleVariants = cva('overflow-visible', {
  variants: {
    maxWidth: {
      default: 'max-w-prose',
      none: '',
    },
    theme: {
      light: 'stroke-lys',
      dark: 'stroke-dark',
      yellow: 'stroke-gul',
    },
    opacity: {
      100: 'opacity-100',
      90: 'opacity-90',
      80: 'opacity-80',
      70: 'opacity-70',
      60: 'opacity-60',
      50: 'opacity-50',
      40: 'opacity-40',
      30: 'opacity-30',
      20: 'opacity-20',
      10: 'opacity-10',
      0: 'opacity-0',
    },
  },
  defaultVariants: {
    maxWidth: 'default',
    theme: 'dark',
    opacity: 20,
  },
})

interface CIRCLE_TYPE {
  maxWidth?: 'default' | 'none'
  theme?: 'light' | 'dark' | 'yellow'
  opacity?: 100 | 90 | 80 | 70 | 60 | 50 | 40 | 30 | 20 | 10 | 0
  className?: string
}

const Circle: React.FC<CIRCLE_TYPE> = ({
  maxWidth,
  theme,
  className,
  opacity,
}) => {
  const transition = {
    delay: 1.5,
    duration: 0.75,
    yoyo: Infinity,
    ease: [0.76, 0, 0.24, 1],
  }

  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="451"
        height="437"
        className={cn(
          CircleVariants({
            className,
            maxWidth,
            theme,
            opacity,
          }),
        )}
      >
        <motion.circle
          cx="225"
          cy="218.5"
          r="213"
          fill="transparent"
          strokeWidth="5"
          initial={{ pathLength: 0 }}
          animate={{ pathLength: 1 }}
          transition={transition}
        />
      </svg>
    </>
  )
}

export default Circle

/* 
















*/
